module.exports = __webpack_public_path__ + "static/media/user_background.dd5b8685.png";